import React from 'react'
import style from "./Property.module.css";

const Car = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>차량번호</p>
        <input type="text" name={`${key_name}_number`} data-index={index} placeholder='45가1889' value={data?.number} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>상세 내용</p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_detail`} data-index={index} placeholder='차량종류, 대략적인 시세, 할부 및 대출 존재하는지 (예: 2018년식 그랜져IG하이브리드, 3042만원에 구입, 현재 시세 1500만원 정도, 차량 대출금 500만원 남음 )' value={data?.detail} onChange={handleInput}/>
        </div>
      </div>
    </div>
  )
}

export default Car